import React from 'react'
import { css } from '@emotion/core'

type CardSelectProps = {
  label?: string
  width?: string
  isResponsible?: boolean
  data?: any
  value?: string
  departmentId?: string
  validation?: string
  isManager?: boolean
  excludeUserIds?: string[]
  onChange?: (e) => void
}

export const CardUsersSelectField: React.FC<CardSelectProps> = ({
  label = '',
  width = '195px',
  isResponsible = false,
  data = [],
  departmentId = '',
  value,
  validation,
  isManager = false,
  excludeUserIds = [],
  onChange,
}) => {
  // 
  const _disabled = (user) => {
    // 既に選択しているユーザーは選択不可
    if (excludeUserIds.length !== 0 && excludeUserIds.includes(user.user_id)) {
      return true
    }
    // マネージャーのみの場合、等級3以下は選択出来ない
    if (isManager && user.rate <= 3) {
      return true
    }
    return false
  }
  return (
    <div css={[wrapperStyle, { width }]} className={'field'}>
      {label && (
        <label css={labelStyle} htmlFor={label}>
          {label}
        </label>
      )}
      <select
        css={validation ? selectErrorStyle : selectStyle}
        id={label}
        name={isResponsible ? 'responsibleUserId' : 'userId'}
        onChange={onChange}
        value={value}
      >
        <option>選択</option>
        {data
          .filter(user => user.department_id === departmentId)
          .map((user: any) => (
            <option key={user.user_id} value={user.user_id} disabled={_disabled(user)}>
              {user.last_name} {user.first_name}
            </option>
          ))}
      </select>
    </div>
  )
}

const wrapperStyle = css({})

const labelStyle = css({
  width: '100%',
  fontSize: '13px',
  fontWeight: 'bold',
  color: '#004CAD',
})

const selectStyle = css({
  appearance: 'none',
  width: '100%',
  border: 'none',
  borderRadius: '6px',
  backgroundColor: '#EDF2F9',
  color: '#151619',
  fontSize: '12px',
  margin: '6px 0 0',
  padding: '14px 22px',
  backgroundImage: `url(${require('@/static/images/arrow_down.svg')})`,
  backgroundPosition: 'right 10px center',
  backgroundSize: '24px',
  backgroundRepeat: 'no-repeat',
})

const selectErrorStyle = css(selectStyle, {
  width: '100%',
  border: '1px solid #FF0000',
})
